export default "__VITE_ASSET__f7ecf5df__"